import React, { useState, useEffect } from "react";
import axios from "axios";
import "./EventGrid.css"; // For styling the grid layout

const EventGrid = () => {
  const [events, setEvents] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  // Fetch events from the server when component mounts
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${apiUrl}/events`);
        setEvents(response.data);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);

  // Toggle isUpcoming flag and update in Firestore
  const toggleIsUpcoming = async (eventId, currentStatus) => {
    try {
      const updatedStatus = !currentStatus;
      await axios.put(`${apiUrl}/events/${eventId}`, {
        isUpcoming: updatedStatus,
      });
      setEvents(events.map(event =>
        event.id === eventId ? { ...event, isUpcoming: updatedStatus } : event
      ));
    } catch (error) {
      console.error("Error toggling isUpcoming:", error);
    }
  };

  // Remove isUpcoming flag (set it to false)
  const removeIsUpcoming = async (eventId) => {
    try {
      await axios.put(`${apiUrl}/events/${eventId}`, {
        isUpcoming: false,
      });
      setEvents(events.map(event =>
        event.id === eventId ? { ...event, isUpcoming: false } : event
      ));
    } catch (error) {
      console.error("Error removing isUpcoming:", error);
    }
  };

  return (
    <div className="event-grid-container">
      <h2>All Events</h2>
      <div className="event-grid">
        {events.map((event) => (
          <div key={event.id} className="event-card">
            <img src={event.imageUrl} alt={event.title} className="event-image" />
            <h3>{event.title}</h3>
            <p>{new Date(event.date).toLocaleString()}</p>
            <a href={event.registrationLink} target="_blank" rel="noopener noreferrer">
              Register Now
            </a>
            <div className="event-actions">
              <button
                onClick={() =>
                  event.isUpcoming
                    ? removeIsUpcoming(event.id)
                    : toggleIsUpcoming(event.id, event.isUpcoming)
                }
                className={`toggle-btn ${event.isUpcoming ? 'remove' : 'add'}`}
              >
                {event.isUpcoming ? "Remove from Upcoming" : "Mark as Upcoming"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventGrid;
